import React from "react";
import { X, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import { formatINR } from "../lib/api";
import { useShop } from "../context/ShopContext";

export default function QuickViewDialog({ open, onClose, product }) {
  const { addToCart } = useShop();
  if (!open || !product) return null;
  const outOfStock = product.stock <= 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={onClose} data-testid="quick-view-dialog">
      <div onClick={(e) => e.stopPropagation()} className="bg-[#111] border border-white/10 max-w-4xl w-full grid md:grid-cols-2 max-h-[90vh] overflow-y-auto">
        <div className="aspect-square bg-[#0a0a0a]">
          <img src={product.images?.[0]} alt={product.name} className="w-full h-full object-cover" />
        </div>
        <div className="p-8 relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white" data-testid="quick-view-close"><X /></button>
          <div className="overline mb-2">{product.subcategory}</div>
          <h2 className="font-display text-3xl uppercase tracking-tight">{product.name}</h2>
          <div className="mt-4 flex items-baseline gap-3">
            <span className="font-display text-2xl text-[#D96A1B]">{formatINR(product.price)}</span>
            {product.compare_price && (
              <span className="text-sm text-white/40 line-through">{formatINR(product.compare_price)}</span>
            )}
            {outOfStock && <span data-testid="qv-sold-out-badge" className="text-xs bg-white/10 text-white/70 font-display tracking-widest px-2 py-1 uppercase">Sold Out</span>}
          </div>
          <p className="mt-5 text-sm text-white/70 font-body leading-relaxed line-clamp-5">{product.description}</p>
          <ul className="mt-5 space-y-1.5">
            {(product.features || []).slice(0, 4).map((f) => (
              <li key={f} className="text-sm text-white/80 font-body flex gap-2"><span className="text-[#D96A1B]">▸</span>{f}</li>
            ))}
          </ul>
          <div className="mt-7 flex flex-col gap-3">
            {outOfStock ? (
              <Link to={`/product/${product.slug}`} onClick={onClose} data-testid="qv-notify-me" className="btn-orange w-full justify-center">
                Notify Me When Back In Stock
              </Link>
            ) : (
              <button
                onClick={() => { addToCart(product, 1); onClose(); }}
                data-testid="qv-add-to-cart"
                className="btn-orange w-full justify-center"
              >
                Add to Cart <ShoppingBag size={16} />
              </button>
            )}
            <Link to={`/product/${product.slug}`} onClick={onClose} data-testid="qv-view-details" className="btn-ghost w-full justify-center">
              View Full Details
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
